module.exports = __webpack_public_path__ + "static/media/sb-error.ad4db721.svg";